export default "__VITE_ASSET__CjTdnrXH__"